import { render } from "./Segment.vue?vue&type=template&id=29adafe4&scoped=true"
import script from "./Segment.vue?vue&type=script&lang=js"
export * from "./Segment.vue?vue&type=script&lang=js"

import "./Segment.vue?vue&type=style&index=0&id=29adafe4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-29adafe4"

export default script